module.exports = __webpack_public_path__ + "media/images/favicon-1db760055e8e11102b0f9d2f008f56cb.ico";